import { render } from "./PBalanceDetails.vue?vue&type=template&id=4d4ebcb4&scoped=true"
import script from "./PBalanceDetails.vue?vue&type=script&lang=js"
export * from "./PBalanceDetails.vue?vue&type=script&lang=js"

import "./PBalanceDetails.vue?vue&type=style&index=0&id=4d4ebcb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4ebcb4"]])

export default __exports__